import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'finIncludes',
  standalone: false,
})
export class IncludesPipe implements PipeTransform {
  transform(array: unknown[] | undefined | null, value: unknown): boolean {
    if (array == null) {
      return false;
    }

    return array.includes(value);
  }
}
